import { graphql, useStaticQuery } from 'gatsby';

const useDefaultGatedRichTextForm = () => {
  const { contentfulInlineMarketingForm } = useStaticQuery(graphql`
    query {
      contentfulInlineMarketingForm(contentful_id: { eq: "4JNvCRQ9hX3niUlAzMs4p4" }) {
        ...InlineMarketingForm
      }
    }
  `);

  return contentfulInlineMarketingForm;
};

export default useDefaultGatedRichTextForm;
